// extracted by mini-css-extract-plugin
module.exports = {"main":"Article_main__1z54l","sidebar":"Article_sidebar__21E-6","recommended":"Article_recommended__3qgzO","title":"Article_title__23Gwb"};